// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"56fd6b6f","89":"5b4a243e","650":"c4174c19","875":"b494c7f2"}[chunkId] + ".chunk.js";
};